import { useMutation, useQuery } from "react-query";
import ReportsApiClient from "api/ReportsApiClient";
import { buildAndWaitForAsyncTask } from "utils";

export function useBuildReport(startBuildingReportFunc, { onSuccess, onError }) {
    const {
        data: task,
        isSuccess: started,
        isLoading: isStarting,
        isError: isErrorStarting,
        reset: resetStart,
        mutate: buildReport,
    } = useMutation(async (args) => await startBuildingReportFunc(args), {
        onError: onError,
    });

    const taskId = task && task.taskId;

    async function queryTaskResult({ signal }) {
        return await buildAndWaitForAsyncTask(
            async () => ({ taskId }),
            async (tid) => await ReportsApiClient.getReportStatus(tid),
            async (tid) => await ReportsApiClient.getReportResult(tid),
            { signal },
        );
    }

    const {
        data,
        isLoading: isWaiting,
        isError: isErrorWaiting,
        remove: removeResult,
    } = useQuery(["build-report-result", taskId], queryTaskResult, {
        enabled: started,
        onSuccess: onSuccess,
        onError: onError,
    });

    const reset = () => {
        resetStart();
        removeResult();
    };

    return {
        build: buildReport,
        data: data,
        isLoading: isStarting || isWaiting,
        isError: isErrorStarting || isErrorWaiting,
        reset: reset,
    };
}
